import { render, staticRenderFns } from "./ui-filter.vue?vue&type=template&id=64f273f2&scoped=true"
import script from "./ui-filter.vue?vue&type=script&lang=js"
export * from "./ui-filter.vue?vue&type=script&lang=js"
import style0 from "./ui-filter.vue?vue&type=style&index=0&id=64f273f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f273f2",
  null
  
)

export default component.exports